import styled from '@emotion/styled';

import { screen } from '@/components/common/breakpoints';
import { Image } from '@/components/common/image';
import { Paragraph } from '@/components/common/MarkUp';

import type { SanityImageAsset } from '@/sanity/sanity.types';
import type { SanityReference } from '@/types/sanity';

export interface PostBodyImageProps {
  image?: {
    _type: 'image';
    asset: SanityReference<SanityImageAsset>;
    alternateText: string;
  };
  alt?: string;
  isDecorativeImage?: boolean;
  caption?: string;
  link?: string;
}

const PostBodyImage = ({
  image,
  isDecorativeImage,
  alt,
  caption,
  link,
}: PostBodyImageProps) => {
  return (
    <Container>
      <ImageContainer>
        {!link && (
          <Image
            {...image}
            alt={alt}
            isDecorativeImage={isDecorativeImage}
            objectFit="contain"
            preserveMaxDimensions
          />
        )}
        {!!link && (
          <a href={link} target="_blank" rel="noopener noreferrer">
            <Image
              {...image}
              alt={alt}
              isDecorativeImage={isDecorativeImage}
              objectFit="contain"
              preserveMaxDimensions
            />
          </a>
        )}
        {!!caption && <Paragraph size="subheading-sm">{caption}</Paragraph>}
      </ImageContainer>
    </Container>
  );
};

const Container = styled.div`
  ${screen.md} {
    padding: var(--spacing-small) 0;
  }
`;
const ImageContainer = styled.div`
  margin-top: var(--spacing-medium);
  margin-bottom: var(--spacing-medium);

  p,
  figcaption {
    text-align: center;
    font-style: italic;
    margin-top: 10px;
  }

  a {
    display: block;
  }

  img {
    max-height: 600px;
  }
  ${screen.md} {
    padding-right: var(--spacing-600);
  }
`;

export { PostBodyImage };
